// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background: black;
    color: #717171;
}
.select-option:hover {
    background: #aeb9d5;
}
.pointer {
    cursor: pointer;
}
.trash-day {
    position: absolute;
    right: 10px;
    top: 5px;
}
ul li {
    list-style: none;
}
li.content-piece {
    font-size: 12px;
    display: inline-block;
    background: #bdbdbd;
    padding: 3px;
    border-radius: 3px;
    margin: 1px;
}
li.content-piece i:hover {
    background: rgba(0, 0, 0, 0.2);
}
li.content-piece:hover {
    background: #ededed;
}
.bg-white-light {
    background: rgba(255, 255, 255, 0.7) !important;
}
input, textarea {
    font-size: 14px;
}
input.transparent, textarea.transparent {
    background: none;
    border: none;
}
input.transparent:focus, textarea.transparent:focus {
    outline: none;
}
input.transparent::placeholder, textarea.transparent::placeholder {
    color: #404040;
}
.content-widget {
    font-size: 12px;
}
.content-widget h3 {
    font-size: 16px;
    text-decoration: underline;
    cursor: pointer;
    text-transform: capitalize;
    float: left;
}
.content-widget select {
    font-size: 12px;
}
.content-widget .search {
    font-size: 20px;
}
.left-side {
    overflow-y: auto;
    position: fixed;
    height: 100vh;
    padding: 5px;
}
.left-side .content {
    background: grey;
    padding: 5px;
    margin-bottom: 5px;
}
.left-side .content ul {
    padding: 0;
}
.left-side .content li {
    cursor: pointer;
}
.day {
    color: #303030;
    border-radius: 5px;
    margin-bottom: 5px;
    background: #e4e4e4;
}
.day input, .day textarea {
    border-radius: 5px;
}
.day h3 {
    font-size: 18px;
    padding: 5px 5px 0px 25px;
}
.day h4 {
    font-size: 16px;
    padding: 5px 5px 0px 5px;
    color: #404040;
}
.day .drag-up, .day .drag-down {
    left: 0;
    position: absolute;
    background: black;
    color: white;
    padding: 0px 3px;
    z-index: 2;
}
.day .drag-up {
    top: 0;
    border-radius: 5px 0px 0px 0px;
}
.day .drag-down {
    bottom: 0;
    border-radius: 0px 0px 0px 5px;
}
.day .column {
    padding: 5px;
    width: 25%;
    margin: 2px;
}
.bcnotifier {
    display: none;
    margin: 0;
    padding: 0;
}
.bcnotifier li {
    padding: 0;
}
.bcnotifier.active {
    display: block;
}
.bcnotifier .alert {
    margin: 0;
    padding: 0;
}
.bcnotifier .alert.alert-info {
    background-color: transparent;
    border: none;
}
.hbar {
    height: 50px;
}
.topbar {
    z-index: 99 !important;
    border-bottom: solid 2px #3b3b3b;
}
.topbar .noti-canvas {
    background: #bdbdbd;
    padding: 5px;
    text-align: left;
    margin-bottom: 0 0 10px 0;
}
.btn-black {
    background: #161819 !important;
    border: none !important;
}
.position-swap {
    display: inline-block;
    width: 20px;
}
.position-swap i {
    display: block;
    padding: 0px 3px;
    margin: 0px;
}
.position-swap i:nth-child(2) {
    margin-top: -5px;
}
.spin {
    animation-name: spining;
    animation-duration: 5000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
@keyframes spining {
    from {
        transform: rotate(0deg);
   }
    to {
        transform: rotate(360deg);
   }
}
/* Toggle Button */
.cm-toggle {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    border: 0;
    outline: 0;
    cursor: pointer;
    margin: 10px;
}
/* To create surface of toggle button */
.cm-toggle:after {
    content: '';
    width: 38px;
    height: 20px;
    display: inline-block;
    background: rgba(196, 195, 195, 0.55);
    border-radius: 18px;
    clear: both;
}
/* Contents before checkbox to create toggle handle */
.cm-toggle:before {
    content: '';
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    left: 0;
    top: 0px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
}
/* Shift the handle to left on check event */
.cm-toggle:checked:before, .cm-toggle-checked:before {
    left: 20px;
    box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.6);
}
/* Background color when toggle button will be active */
.cm-toggle:checked:after, .cm-toggle-checked:after {
    background: #16a085;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+CAA+C;AACnD;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,OAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,MAAM;IACN,8BAA8B;AAClC;AACA;IACI,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,mCAAmC;IACnC,iCAAiC;AACrC;AACA;IACI;QACI,uBAAuB;GAC5B;IACC;QACI,yBAAyB;GAC9B;AACH;AACA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,wCAAwC;IACxC,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,YAAY;AAChB;AACA,uCAAuC;AACvC;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,qCAAqC;IACrC,mBAAmB;IACnB,WAAW;AACf;AACA,qDAAqD;AACrD;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;AACA,4CAA4C;AAC5C;IACI,UAAU;IACV,2CAA2C;AAC/C;AACA,uDAAuD;AACvD;IACI,mBAAmB;AACvB","sourcesContent":["body {\n    background: black;\n    color: #717171;\n}\n.select-option:hover {\n    background: #aeb9d5;\n}\n.pointer {\n    cursor: pointer;\n}\n.trash-day {\n    position: absolute;\n    right: 10px;\n    top: 5px;\n}\nul li {\n    list-style: none;\n}\nli.content-piece {\n    font-size: 12px;\n    display: inline-block;\n    background: #bdbdbd;\n    padding: 3px;\n    border-radius: 3px;\n    margin: 1px;\n}\nli.content-piece i:hover {\n    background: rgba(0, 0, 0, 0.2);\n}\nli.content-piece:hover {\n    background: #ededed;\n}\n.bg-white-light {\n    background: rgba(255, 255, 255, 0.7) !important;\n}\ninput, textarea {\n    font-size: 14px;\n}\ninput.transparent, textarea.transparent {\n    background: none;\n    border: none;\n}\ninput.transparent:focus, textarea.transparent:focus {\n    outline: none;\n}\ninput.transparent::placeholder, textarea.transparent::placeholder {\n    color: #404040;\n}\n.content-widget {\n    font-size: 12px;\n}\n.content-widget h3 {\n    font-size: 16px;\n    text-decoration: underline;\n    cursor: pointer;\n    text-transform: capitalize;\n    float: left;\n}\n.content-widget select {\n    font-size: 12px;\n}\n.content-widget .search {\n    font-size: 20px;\n}\n.left-side {\n    overflow-y: auto;\n    position: fixed;\n    height: 100vh;\n    padding: 5px;\n}\n.left-side .content {\n    background: grey;\n    padding: 5px;\n    margin-bottom: 5px;\n}\n.left-side .content ul {\n    padding: 0;\n}\n.left-side .content li {\n    cursor: pointer;\n}\n.day {\n    color: #303030;\n    border-radius: 5px;\n    margin-bottom: 5px;\n    background: #e4e4e4;\n}\n.day input, .day textarea {\n    border-radius: 5px;\n}\n.day h3 {\n    font-size: 18px;\n    padding: 5px 5px 0px 25px;\n}\n.day h4 {\n    font-size: 16px;\n    padding: 5px 5px 0px 5px;\n    color: #404040;\n}\n.day .drag-up, .day .drag-down {\n    left: 0;\n    position: absolute;\n    background: black;\n    color: white;\n    padding: 0px 3px;\n    z-index: 2;\n}\n.day .drag-up {\n    top: 0;\n    border-radius: 5px 0px 0px 0px;\n}\n.day .drag-down {\n    bottom: 0;\n    border-radius: 0px 0px 0px 5px;\n}\n.day .column {\n    padding: 5px;\n    width: 25%;\n    margin: 2px;\n}\n.bcnotifier {\n    display: none;\n    margin: 0;\n    padding: 0;\n}\n.bcnotifier li {\n    padding: 0;\n}\n.bcnotifier.active {\n    display: block;\n}\n.bcnotifier .alert {\n    margin: 0;\n    padding: 0;\n}\n.bcnotifier .alert.alert-info {\n    background-color: transparent;\n    border: none;\n}\n.hbar {\n    height: 50px;\n}\n.topbar {\n    z-index: 99 !important;\n    border-bottom: solid 2px #3b3b3b;\n}\n.topbar .noti-canvas {\n    background: #bdbdbd;\n    padding: 5px;\n    text-align: left;\n    margin-bottom: 0 0 10px 0;\n}\n.btn-black {\n    background: #161819 !important;\n    border: none !important;\n}\n.position-swap {\n    display: inline-block;\n    width: 20px;\n}\n.position-swap i {\n    display: block;\n    padding: 0px 3px;\n    margin: 0px;\n}\n.position-swap i:nth-child(2) {\n    margin-top: -5px;\n}\n.spin {\n    animation-name: spining;\n    animation-duration: 5000ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n}\n@keyframes spining {\n    from {\n        transform: rotate(0deg);\n   }\n    to {\n        transform: rotate(360deg);\n   }\n}\n/* Toggle Button */\n.cm-toggle {\n    -webkit-appearance: none;\n    -webkit-tap-highlight-color: transparent;\n    position: relative;\n    border: 0;\n    outline: 0;\n    cursor: pointer;\n    margin: 10px;\n}\n/* To create surface of toggle button */\n.cm-toggle:after {\n    content: '';\n    width: 38px;\n    height: 20px;\n    display: inline-block;\n    background: rgba(196, 195, 195, 0.55);\n    border-radius: 18px;\n    clear: both;\n}\n/* Contents before checkbox to create toggle handle */\n.cm-toggle:before {\n    content: '';\n    width: 20px;\n    height: 20px;\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 0px;\n    border-radius: 50%;\n    background: #fff;\n    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);\n}\n/* Shift the handle to left on check event */\n.cm-toggle:checked:before, .cm-toggle-checked:before {\n    left: 20px;\n    box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.6);\n}\n/* Background color when toggle button will be active */\n.cm-toggle:checked:after, .cm-toggle-checked:after {\n    background: #16a085;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
